import { css } from "styled-components";

export const Colors = css`
    --color-black: #101010;
    --color-midnight: #1a1a1f;
    --color-white: #fff;

    --color-red: #b12a31;
    --color-green: #4caf50;
    --color-electrified-blue: #0072f0;
    --color-sky-blue: #005fb6;
    --color-azure-hover: #4d5e7d;
    --color-azure: #20365c;
    --color-cloud: #eeedec;

    --color-mist: #f4f6fb;
    --color-silver: #e2e8ef;
    --color-platinum-light: #c7cfd7;
    --color-platinum-medium: #b0b8c0;
    --color-titanium: #969ca3;
    --color-brushed-steel: #6c6f76;
    --color-platinum-dark: #52565e;
    --color-steel: #363840;

    --color-eco-a: #33a357;
    --color-eco-b: #79b752;
    --color-eco-c: #c3d545;
    --color-eco-d: #fff12c;
    --color-eco-e: #edb731;
    --color-eco-f: #d66f2c;
    --color-eco-g: #cc232a;
    --color-eco-default: #020202;
`;

export const Dropshadows = css`
    --dropshadow-sm: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    --dropshadow-md: 0px 15px 80px 0px rgba(0, 0, 0, 0.04), 0px 4.522px 24.118px 0px rgba(0, 0, 0, 0.05),
        0px 1.878px 10.017px 0px rgba(0, 0, 0, 0.03), 0px 0.679px 3.623px 0px rgba(0, 0, 0, 0.02);
    --dropshadow-lg: 0px 15px 80px 0px rgba(0, 0, 0, 0.04), 0px 4.522px 24.118px 0px rgba(0, 0, 0, 0.05),
        0px 1.878px 10.017px 0px rgba(0, 0, 0, 0.03), 0px 0.679px 3.623px 0px rgba(0, 0, 0, 0.02);
`;

export const Fonts = css`
    --font-light: "Nobel Light", Arial, Helvetica, sans-serif;
    --font-book: "Nobel Book", Arial, Helvetica, sans-serif;
    --font-regular: "Nobel Regular", Arial, Helvetica, sans-serif;
    --font-bold: "Nobel Bold", Arial, Helvetica, sans-serif;
`;

/* Use px for default spacing since they shouldn't have to increase when increasing base font-size */
export const Spacers = css`
    --spacing-0: 0;
    --spacing-1: 8px;
    --spacing-2: 16px;
    --spacing-3: 24px;
    --spacing-4: 32px;
    --spacing-5: 40px;
    --spacing-6: 48px;
    --spacing-7: 56px;
    --spacing-8: 64px;
    --spacing-9: 72px;
    --spacing-10: 80px;
    --spacing-11: 120px;
`;

export const ZIndex = css`
    --z-index-popup: 700;
    --z-index-dropdown: 1000;
    --z-index-navbar: 1010;
    --z-index-sticky: 1020;
    --z-index-fixed: 1030;
    --z-index-modalbackdrop: 1040;
    --z-index-modal: 1050;
    --z-index-overlay: 1060;
    --z-index-tooltip: 1070;
`;
